<template src="./AdminVisionClinics.html" />

<script>
import dashboardClinic from "../DashboardClinic/DashboardClinic.vue"
import pendingSchedule from "../Schedule/PendingSchedule/PendingSchedule.vue"
import appointmentScheduled from "../Schedule/AppointmentScheduled/AppointmentScheduled.vue"
import appointmentPerformed from "../Schedule/AppointmentPerformed/AppointmentPerformed.vue"
import doctors from "../Doctors/Doctors.vue"
import technicalManager from "../TechnicalManager/TechnicalManager.vue"
import clinicAndProfessionals from "../ClinicAndProfessionals/ClinicAndProfessionals.vue"
import contracts from "../Contracts/Contracts.vue"
import campaigns from "../Campaigns/Campaigns.vue"
import extract from "../../Doctor/FinancialExtract/FinancialExtract"
import Balance from "@/views/pages/Balance/Balance.vue"

export default {
  components: {
    "dashboard-clinic": dashboardClinic,
    "pending-schedule": pendingSchedule,
    "appointment-scheduled": appointmentScheduled,
    "appointment-performed": appointmentPerformed,
    "financial-extract": extract,
    "doctors": doctors,
    "technical-manager": technicalManager,
    "clinic-and-professionals": clinicAndProfessionals,
    Balance,
    contracts,
    campaigns
  },
  data () {
    return {
      clinicName: "",
      bearerDefault: "",
      dashboardClinicShow: false,
      pendingScheduleShow: false,
      appointmentScheduledShow: false,
      appointmentPerformedShow: false,
      balanceShow: false,
      financialExtractShow: false,
      addDoctorShow: false,
      technicalManagerShow: false,
      clinicAndProfessionalsShow: false,
      contractsShow: false,
      campaignsShow: false
    }
  },
  mounted () {
    const vm = this
    vm.bearerDefault = vm.$session.get("bearerDefault")
    vm.$session.set("bearerDefault", vm.bearerDefault)
    if (vm.$route.params) {
      vm.clinicName = vm.$route.params.name.toUpperCase()
      vm.init()
    }
  },
  methods: {
    init () {
      const vm = this
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      )
      vm.$session.set("clinicId", vm.$route.params.id)
      vm.axios
        .put(
          vm.$store.state.filooServer +
          "admin/webclinics/" +
          vm.$route.params.id +
          "/getAssume"
        )
        .then(function (response) {
          vm.authenticateAsAdmin(response.data.token)
        })
    },
    showContracts () {
      const vm = this
      vm.dashboardClinicShow = false
      vm.pendingScheduleShow = false
      vm.appointmentScheduledShow = false
      vm.appointmentPerformedShow = false
      vm.balanceShow = false
      vm.financialExtractShow = false
      vm.addDoctorShow = false
      vm.technicalManagerShow = false,
        vm.clinicAndProfessionalsShow = false
      vm.contractsShow = true
      vm.campaignsShow = false
    },
    showCampaigns () {
      const vm = this
      vm.dashboardClinicShow = false
      vm.pendingScheduleShow = false
      vm.appointmentScheduledShow = false
      vm.appointmentPerformedShow = false
      vm.balanceShow = false
      vm.financialExtractShow = false
      vm.addDoctorShow = false
      vm.technicalManagerShow = false,
        vm.clinicAndProfessionalsShow = false
      vm.contractsShow = false
      vm.campaignsShow = true
    },
    showDashboardClinic () {
      const vm = this
      vm.dashboardClinicShow = true
      vm.pendingScheduleShow = false
      vm.appointmentScheduledShow = false
      vm.appointmentPerformedShow = false
      vm.balanceShow = false
      vm.financialExtractShow = false
      vm.addDoctorShow = false
      vm.technicalManagerShow = false,
        vm.clinicAndProfessionalsShow = false
      vm.contractsShow = false
      vm.campaignsShow = false
    },
    showPendingSchedule () {
      const vm = this
      vm.dashboardClinicShow = false
      vm.pendingScheduleShow = true
      vm.appointmentScheduledShow = false
      vm.appointmentPerformedShow = false
      vm.balanceShow = false
      vm.financialExtractShow = false
      vm.addDoctorShow = false
      vm.technicalManagerShow = false,
        vm.clinicAndProfessionalsShow = false
      vm.contractsShow = false
      vm.campaignsShow = false
    },
    showAppointmentScheduled () {
      const vm = this
      vm.dashboardClinicShow = false
      vm.pendingScheduleShow = false
      vm.appointmentScheduledShow = true
      vm.appointmentPerformedShow = false
      vm.balanceShow = false
      vm.financialExtractShow = false
      vm.addDoctorShow = false
      vm.technicalManagerShow = false,
        vm.clinicAndProfessionalsShow = false
      vm.contractsShow = false
      vm.campaignsShow = false
    },
    showAppointmentPerformed () {
      const vm = this
      vm.dashboardClinicShow = false
      vm.pendingScheduleShow = false
      vm.appointmentScheduledShow = false
      vm.appointmentPerformedShow = true
      vm.balanceShow = false
      vm.financialExtractShow = false
      vm.addDoctorShow = false
      vm.technicalManagerShow = false,
        vm.clinicAndProfessionalsShow = false
      vm.contractsShow = false
      vm.campaignsShow = false
    },
    showAddDoctor () {
      const vm = this
      vm.dashboardClinicShow = false
      vm.pendingScheduleShow = false
      vm.appointmentScheduledShow = false
      vm.appointmentPerformedShow = false
      vm.addDoctorShow = true
      vm.technicalManagerShow = false,
        vm.balanceShow = false
      vm.financialExtractShow = false
      vm.clinicAndProfessionalsShow = false
      vm.contractsShow = false
      vm.campaignsShow = false
    },
    showTechnicalManager () {
      const vm = this
      vm.dashboardClinicShow = false
      vm.pendingScheduleShow = false
      vm.appointmentScheduledShow = false
      vm.appointmentPerformedShow = false
      vm.addDoctorShow = false
      vm.technicalManagerShow = true,
        vm.balanceShow = false
      vm.financialExtractShow = false
      vm.clinicAndProfessionalsShow = false
      vm.contractsShow = false
      vm.campaignsShow = false
    },
    showBalance () {
      const vm = this
      vm.dashboardClinicShow = false
      vm.pendingScheduleShow = false
      vm.appointmentScheduledShow = false
      vm.appointmentPerformedShow = false
      vm.balanceShow = true
      vm.financialExtractShow = false
      vm.addDoctorShow = false
      vm.technicalManagerShow = false,
        vm.clinicAndProfessionalsShow = false
      vm.contractsShow = false
      vm.campaignsShow = false
    },
    showFinancialExtract () {
      const vm = this
      vm.dashboardClinicShow = false
      vm.pendingScheduleShow = false
      vm.appointmentScheduledShow = false
      vm.appointmentPerformedShow = false
      vm.balanceShow = false
      vm.financialExtractShow = true
      vm.addDoctorShow = false
      vm.technicalManagerShow = false,
        vm.clinicAndProfessionalsShow = false
      vm.contractsShow = false
      vm.campaignsShow = false
    },
    showClinicAndProfessionals () {
      const vm = this
      vm.dashboardClinicShow = false
      vm.pendingScheduleShow = false
      vm.appointmentScheduledShow = false
      vm.appointmentPerformedShow = false
      vm.balanceShow = false
      vm.financialExtractShow = false
      vm.addDoctorShow = false
      vm.technicalManagerShow = false,
        vm.clinicAndProfessionalsShow = true
      vm.contractsShow = false
      vm.campaignsShow = false
    },
    authenticateAsAdmin (token) {
      const vm = this
      vm.axios
        .put(vm.$store.state.filooServer + "webclinics/assume/" + token)
        .then(function (response) {
          vm.$session.set("bearer", response.headers.authorization)
          vm.dashboardClinicShow = true
        })
    },
    goToClinicsRegistered () {
      const vm = this
      vm.$session.set("bearer", vm.bearerDefault)
      vm.$session.start()
      vm.$router.push("/clinics-registered")
    }
  }
}
</script>

<style lang="scss" src="./AdminVisionClinics.scss"></style>
